import Compressor from 'compressorjs';
// https://github.com/fengyuanchen/compressorjs
const compressorSettings = {
    mode : 'strict',
    quality : 0.8,
    threshold : 127,
    speed : 'low'
};
export function comprimir(reductorDeFactorCalidad, file, restricciones, callback, descartarImagenCallback)
{
    compressorSettings.mimeType = file.Type;

    if(reductorDeFactorCalidad <= 0.3)
    {
        if(reductorDeFactorCalidad)
        compressorSettings.quality = parseFloat((0.8 - reductorDeFactorCalidad).toFixed(1));

        new Compressor(file, {...compressorSettings, success: (result) => {
            // console.log("Foto comprimida con libreria: " + result.size / 1000000 + "MB");
            callback(result);
        }, error: (error) => {
            descartarImagenCallback(error);
        }});
    }
    else
    {
        //var resize_width = maxWidth; // maximo definido en la interfaz de foro
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.name = file.name;
        reader.size = file.size;

        reader.onload = function(event) {
            var img = new Image();
            img.src = event.target.result;
            img.name = event.target.name;
            img.size = event.target.size;

            img.onload = function(el) {
                var elem = document.createElement('canvas');
                
                // se escala al width definido y se mantiene el ratio 
                let resize_width = el.target.width - (el.target.width * 0.3);

                var scaleFactor = resize_width / el.target.width;
                elem.width = resize_width;
                elem.height = el.target.height * scaleFactor;
                // lo dibujo en canvas
                var ctx = elem.getContext('2d');
                ctx.drawImage(el.target, 0, 0, elem.width, elem.height);
                
                if(elem.width < restricciones.minWidth && elem.height < restricciones.minHeight)
                    descartarImagenCallback();
                else
                {
                    // obtengo el blob, valido el size y si es correcto hago el request
                    ctx.canvas.toBlob((blob) => {
                        callback(blob);
                    },file.type,1);
                }
                
            }
        }
    }
    

    

    
    

}